import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import SweetAlert2 from "react-sweetalert2";
import * as actions from "../redux/ReportAction";
import { useNavigate } from "react-router-dom";
import DateRangeComp from "../../common/DateRangeComp";
import { subDays, format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { AgentDownlineMember } from "./AgentDownlineMember";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";

export const GameSummaryReportList = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  // const [fromDate, setFromDate] = useState(subDays(new Date(), 7));
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [selMemberId, setSelMemberId] = useState(null);
  const [selMemberName, setSelMemberName] = useState(null);
  const [memberReportDetailsVisible, setMemberReportDetailsVisible] =
    useState(false);
  const reportState = useSelector(({ report }) => report, shallowEqual);
  const timeZone = "Asia/Kuala_Lumpur";

  useEffect(() => {
    const timeZone = "Asia/Kuala_Lumpur";
    const queryParams = {
      action: "membergamesumreport",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
    };
    dispatch(actions.callSummaryReportList(queryParams));
  }, [dispatch]);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = () => {
    setSelMemberId(null);
    const queryParams = {
      action: "membergamesumreport",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
    };

    dispatch(actions.callSummaryReportList(queryParams)).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };
  const customCardClass =
    "rounded d-flex align-items-center justify-content-spacebetween py-2";

  return (
    <div style={{ width: "98%", margin: "5px auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <AgentDownlineMember
        selMemberId={selMemberId}
        selMemberName={selMemberName}
        fromDate={fromDate}
        toDate={toDate}
        memberReportDetailsVisible={memberReportDetailsVisible}
        onClose={() => setMemberReportDetailsVisible(false)}
      />
      <div>
        <h2>{intl.formatMessage({ id: "gameSummaryReport" })}</h2>
      </div>
      <div className="dateSearch-div">
        <div className="dateRange-div">
          <DateRangeComp
            initialRange={[
              { startDate: fromDate, endDate: toDate, key: "selection" },
            ]}
            onDateChange={handleDateChange}
          />
        </div>
        <div>
          <button
            className="btn btn-primary"
            onClick={() => handleSearchClick()}
          >
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>
      <div>
        {reportState && reportState.summaryReportLists && (
          <div
            className={`${customCardClass} gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow`}
            style={{
              border: "1px solid grey",
              padding: "2px",
              margin: "10px 0 ",
            }}
          >
            <div style={{ width: "100%" }}>
              <table
                className="text-start table-report"
                style={{
                  width: "100%",
                  minWidth: "600px",
                }}
              >
                <tbody>
                  <tr
                    style={{
                      borderBottom: "1px solid rgba(175, 164, 164, 0.4)",
                    }}
                  >
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "totalGameIn" }) +
                        " : " +
                        reportState.summaryReportLists.totalgamein}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "totalGameOut" }) +
                        " : " +
                        reportState.summaryReportLists.totalgameout}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "totalGameProfit" }) +
                        " : " +
                        reportState.summaryReportLists.totalgameprofit}
                    </td>
                  </tr>
                  <tr>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "total4dBet" }) +
                        " : " +
                        reportState.summaryReportLists.total4dbet}
                    </td>
                    <td className="col-3 td-line">
                      {intl.formatMessage({ id: "total4dWin" }) +
                        " : " +
                        reportState.summaryReportLists.total4dwin}
                    </td>
                    <td className="col-3 td-line"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {/* <div style={{ color: "#FF8000" }}>
        <div>{intl.formatMessage({ id: "totalInRemark" })}</div>
        <div>{intl.formatMessage({ id: "totalOutRemark" })}</div>
      </div> */}
      {/* <div>
          {reportState && reportState.agentReportLists && (
            <div>
              <div>
                {intl.formatMessage({ id: "totalBet" }) +
                  " : " +
                  reportState.agentReportLists.totalbet}
              </div>
              <div>
                {intl.formatMessage({ id: "totalWin" }) +
                  " : " +
                  reportState.agentReportLists.totalwin}
              </div>
              <div>
                {intl.formatMessage({ id: "totalProfit" }) +
                  " : " +
                  reportState.agentReportLists.totalprofit}
              </div>
            </div>
          )}
        </div> */}
      <div
        className="member-div d-flex"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell hide-on-mobile col-1">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="member-cell col-2 text-start text-nowrap">
                    {intl.formatMessage({ id: "username" })}
                  </th>
                  <th className="member-cell col-2 text-end text-nowrap">
                    {intl.formatMessage({ id: "gameIn" })}
                  </th>
                  <th className="member-cell col-2 text-end text-nowrap">
                    {intl.formatMessage({ id: "gameOut" })}
                  </th>
                  <th className="member-cell col-2 text-nowrap text-end text-nowrap">
                    {intl.formatMessage({ id: "gameProfit" })}
                  </th>
                  <th className="member-cell col-2 text-nowrap text-end">
                    {"4" + intl.formatMessage({ id: "DBet" })}
                  </th>
                  <th className="member-cell col-2 text-nowrap text-end">
                    {4 + intl.formatMessage({ id: "DWin" })}
                  </th>
                  <th className="member-cell col-2 text-nowrap text-end">
                    {intl.formatMessage({ id: "action" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {reportState.summaryReportLists &&
                reportState.summaryReportLists.memberGameSummaryReports &&
                reportState.summaryReportLists.memberGameSummaryReports.length >
                  0 ? (
                  reportState.summaryReportLists.memberGameSummaryReports.map(
                    (report, index) => (
                      <tr key={index} className="member-row1">
                        <td className="member-cell hide-on-mobile col-1">
                          {index + 1}
                        </td>
                        <td className="member-cell col-2 text-start">
                          {report.username}
                        </td>
                        <td className="member-cell col-2 text-end">
                          {report.totalgamein}
                        </td>
                        <td className="member-cell col-2 text-end">
                          {report.totalgameout}
                        </td>
                        <td
                          className="member-cell col-2 text-end"
                          style={{
                            color: report.totalgameprofit.includes("-")
                              ? "red"
                              : "green",
                          }}
                        >
                          {report.totalgameprofit}
                        </td>
                        <td className="member-cell col-2 text-end">
                          {report.total4dbet}
                        </td>
                        <td className="member-cell col-2 text-end">
                          {report.total4dwin}
                        </td>
                        <td>
                          <button
                            className="btn btn-primary mx-1"
                            onClick={() => {
                              setSelMemberId(report.memberid);
                              setSelMemberName(report.username);
                              setMemberReportDetailsVisible(true);
                            }}
                          >
                            <i className="bi bi-exclamation-circle" />
                          </button>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="7">
                      <div className="no-record-wrapper oRecordDiv">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
              {/* <tfoot>
                {reportState && reportState.summaryReportLists && (
                  <tr
                    className="member-row1"
                    style={{ borderTop: "1px solid rgba(175, 164, 164, 0.4)" }}
                  >
                    <td className="member-cell hide-on-mobile col-1"></td>
                    <td className="member-cell col-2 text-end">
                      {intl.formatMessage({ id: "total" }) + " : "}
                    </td>
                    <td className="member-cell col-2 text-end">
                      {reportState.summaryReportLists.totalin}
                    </td>
                    <td className="member-cell col-2 text-end">
                      {reportState.summaryReportLists.totalout}
                    </td>
                    <td className="member-cell col-2 text-end">
                      {reportState.summaryReportLists.totalprofit}
                    </td>
                    <td className="member-cell col-2 text-end">
                      {reportState.summaryReportLists.totalprogressivebet}
                    </td>
                    <td className="member-cell col-2 text-end">
                      {reportState.summaryReportLists.totalprogressivewin}
                    </td>
                  </tr>
                )}
              </tfoot> */}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
